import { render, staticRenderFns } from "./PeopleStore.vue?vue&type=template&id=4f59a2e7&scoped=true"
import script from "./PeopleStore.vue?vue&type=script&lang=js"
export * from "./PeopleStore.vue?vue&type=script&lang=js"
import style0 from "./PeopleStore.vue?vue&type=style&index=0&id=4f59a2e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59a2e7",
  null
  
)

export default component.exports